/* eslint-disable max-len */

/**
 * @author: Matthew Rawson @ 04/09/2017 14:47
 * @description: Custom TopUpCard Icon created as a React element in a similar manner to react-icons.
 * @notes: Could be moved to icon font file when that is implemented
 */
import React from "react"
import BaseSvgIcon from "./Base"

export default function TimeLimitedPerk(props) {
  const viewBox = "-5 -5 28 28"
  return (
    <BaseSvgIcon {...props} viewBox={viewBox}>
      <g id="ICON_CLOCK" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-6" stroke="#4A4A4A">
          <g id="Group-4">
            <circle id="Oval" cx="11" cy="11" r="11" />
          </g>
        </g>
        <g id="Group-6" transform="translate(9.000000, 9.000000)" stroke="#4A4A4A">
          <g id="Group-4">
            <circle id="Oval" cx="2" cy="2" r="2" />
          </g>
        </g>
        <path d="M11,9 L11,2.5" id="Path-8" stroke="#4A4A4A" strokeLinecap="round" />
        <path d="M13,12 L17,14" id="Path-9" stroke="#4A4A4A" strokeLinecap="round" />
      </g>
    </BaseSvgIcon>
  )
}
